import { takeEvery } from 'redux-saga/effects';
import { getType } from 'typesafe-actions';

import * as companyActions from './actions';
import { apiSagaV2 } from '../../../helpers/saga';
import { AdminApi } from 'src/api';

const getCompaniesSaga = apiSagaV2(companyActions.getCompanies, async (connection, action) => {
  const { page, searchText } = action.payload;

  return new AdminApi(connection).getCompanies(page, searchText);
});

const editCompanySaga = apiSagaV2(companyActions.editCompany, async (connection, action) => {
  const { companyId, data } = action.payload;

  return new AdminApi(connection).editCompany(companyId, data);
});

const addCompanySaga = apiSagaV2(companyActions.addCompany, async (connection, action) => {
  const { data } = action.payload;

  return new AdminApi(connection).addCompany(data);
});

export function* companiesSagas() {
  yield takeEvery(getType(companyActions.getCompanies.request), getCompaniesSaga);
  yield takeEvery(getType(companyActions.editCompany.request), editCompanySaga);
  yield takeEvery(getType(companyActions.addCompany.request), addCompanySaga);
}
